// extracted by mini-css-extract-plugin
export default {"indicator":"tabs_indicator__Jfsx7"};